export enum ConditionOperator {
  OR = 'or',
  AND = 'and',
}
